import { Language } from '@/interfaces'

export const enEmails: Language = {
  contactSubjectInventory: '{accountId} vHub product inventory',

  contactMessageInventoryTable:
    'I want to share with you the following information regarding inventory in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• {accountId} Part Number: {cpn} \n' +
    '• Product Group: {productGroup} \n' +
    '• Design ID: {designId} \n' +
    '• Micron Part Number: {mpn} \n' +
    '• Total Inventory: {totalInventory} \n' +
    '• Available Quantity: {availableQuantity} \n',
  contactMessageInventoryDetail:
    'I want to share with you the following information regarding inventory in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• Total vHub Inventory: {totalQuantity} \n' +
    '• Available: {availableQuantity} \n' +
    '• Pull Pending: {pullPendingQuantity} \n' +
    '• Shipments from vHub: {shippedQuantity} \n' +
    '• Replenishments into vHub: {replenishments} \n' +
    '• Physical Hub Inventory: {physicalHubQuantity} \n',

  contactSubjectPullsPending: '{accountId} vHub Pull Pending Information',
  contactMessagePullsPendingTable:
    'I want to share with you the following information regarding pending pulls in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• Sales Order: {salesOrderNumber} \n' +
    '• PO: {purchaseOrderId} \n' +
    '• {accountId} Part Number: {cpn} \n' +
    '• Pull Requested: {dateScheduled} \n' +
    '• Micron Part Number: {mpn} \n' +
    '• Unit Quantity: {quantity} \n' +
    '• Expected Ship Date: {materialAvailableDate} \n' +
    '• Ship to: {shipTo} \n' +
    '• Status: {status} \n',
  contactMessagePullsPendingDetail:
    'I want to share with you the following information regarding pulls pending in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• Expected Ship Date: {materialAvailableDate} \n' +
    '• Requested by: {requestedBy} \n' +
    '• Status: {status} \n' +
    '• Quantity: {quantity} \n' +
    '• Pull Type: {pullType} \n' +
    '• {accountId} Part Number: {cpn} \n' +
    '• Micron Part Number: {mpn} \n' +
    '• PO: {purchaseOrderId} \n' +
    '• Ship to: {shipTo} \n' +
    '• Sold to: {soldTo} \n',

  contactSubjectPullsHistory: '{accountId} vHub Pull History Information',
  contactMessagePullsHistoryTable:
    'I want to share with you the following information regarding pulls history in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• Sales Order: {salesOrderNumber} \n' +
    '• PO: {purchaseOrderId} \n' +
    '• {accountId} Part Number: {cpn} \n' +
    '• Micron Part Number: {mpn} \n' +
    '• Unit Quantity: {quantity} \n' +
    '• Ship Date: {dateShipped} \n' +
    '• Pull Requested: {dateScheduled} \n' +
    '• Requested by: {requestedBy} \n' +
    '• Status: {status} \n',
  contactMessagePullsHistoryDetail:
    'I want to share with you the following information regarding pulls history in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• Sales Order: {salesOrderNumber} \n' +
    '• Pull Created: {dateCreated} \n' +
    '• Requested ship date: {dateScheduled} \n' +
    '• Requested by: {requestedBy} \n' +
    '• Status: {status} \n' +
    '• Quantity: {quantity} \n' +
    '• Pull Type: {pullType} \n' +
    '• {accountId} Part Number: {cpn} \n' +
    '• Micron Part Number: {mpn} \n' +
    '• PO: {purchaseOrderId} \n' +
    '• Ship to: {shipTo} \n' +
    '• Sold to: {soldTo} \n',

  contactSubjectShipments: '{accountId} vHub Shipments Information',
  contactMessageShipmentsTable:
    'I want to share with you the following information regarding shipments in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• Sales Order: {salesOrderNumber} \n' +
    '• PO: {purchaseOrderId} \n' +
    '• {accountId} Part Number: {cpn} \n' +
    '• Micron Part Number: {mpn} \n' +
    '• Unit Quantity: {quantity} \n' +
    '• Ship Date: {dateShipped} \n' +
    '• Delivery Number: {deliveryNumber} \n' +
    '• Carrier Number:  {carrierTracking} \n' +
    '• Ship to City: {shipToCity} \n',
  contactMessageShipmentsDetail:
    'I want to share with you the following information regarding shipments in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• Carrier Number:  {carrierTracking} \n' +
    '• Shipped: {dateShipped} \n' +
    '• {accountId} Part Number: {cpn} \n' +
    '• Sales Order: {salesOrderNumber} \n' +
    '• Delivery Number: {deliveryNumber} \n' +
    '• Ship to: {shipTo} \n' +
    '• Sold to: {soldTo} \n' +
    '• Unit Quantity: {quantity} \n' +
    '• Customer PO Number: {purchaseOrderId} \n' +
    '• Micron Part Number: {mpn} \n' +
    '• Design ID: {designId} \n' +
    '• Pull Type: {pullType} \n' +
    '• Requested by: {requestedBy} \n',

  contactSubjectReplenishments: '{accountId} vHub Product Replenishments Information',
  contactMessageReplenishmentsTable:
    'I want to share with you the following information regarding product replenishments in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• {accountId} Part Number: {cpn} \n' +
    '• Product Group: {productGroup} \n' +
    '• Design ID: {designId} \n' +
    '• Micron Part Number: {mpn} \n' +
    '• Calendar Week:\n{calendarWeek} \n',

  contactSubjectReplenishmentsRaw: '{accountId} vHub Replenishment Information',
  contactMessageReplenishmentsRawTable:
    'I want to share with you the following information regarding a replenishment in the {accountId} vHub: \n\n' +
    '• Link: {pageUrl} \n' +
    '• {accountId} Part Number: {cpn} \n' +
    '• Product Group: {productGroup} \n' +
    '• Design ID: {designId} \n' +
    '• Micron Part Number: {mpn} \n' +
    '• Quantity:{quantity} \n' +
    '• Calendar Week:\n{calendarWeek} \n',

  contactMessageFormattedAddress:
    '{name}{name2}\n {street}\n {city} {region}, {postalCode}\n {country}',
}
